import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { SavePackageModel, OkvedModel, OkvedPackageModel } from 'Pages/registratorCabinet'

export const OkvedsBlockApi = {
	getAllOkvedsRbidosRequestApi: async () => {
		const res = await axiosDS().get<OkvedModel[]>(urls.cabinet.okveds)
		return res.data
	},
	createOkvedPackage: async (data: SavePackageModel) => {
		const res = await axiosDS().post<OkvedPackageModel>(urls.cabinet.okved_packages, { data })
		return res.data
	},
}
